<button #innerButton width="100%" height="100%" [ngClass]="{'disabled-class': wizDisabled}"
  class="innerfocus-class" [disabled]='wizDisabled'
  (click)="onClick()" (dblclick)="onDoubleClick()" (focus)="wizOnFocus()"
  [wizTooltip]="translatedTooltip">
  <div [ngClass]="{
    'inner-button': true,
    'right': iconPlacement === 'right',
    'left': iconPlacement === 'left',
    'no-label': hasLabel === false
  }">
    <wiz-image #img [hidden]="!wizImage"
    style=" height: inherit;"
    [ngClass]="{'disabled-class': wizDisabled}"
    [sourceObservable]="wizImage"></wiz-image>
    <wiz-icon [hidden]="!wizIcon" style="color: inherit;">{{wizIcon}}</wiz-icon>

    <mat-icon [hidden]="!wizMaterial" style="color: inherit;" role="img" 
    class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" 
    aria-hidden="true" data-mat-icon-type="font">{{wizMaterial}}</mat-icon>

    <wiz-label class="innerLabel" *ngIf="wizLabel"
    [wizLabel]="wizLabel"></wiz-label>
  </div>
</button>
